import {withComponent} from '../../hoc/withComponent';
import {TableRowBase} from './TableRowBase';

export const withTableRow = withComponent(TableRowBase);
